import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col } from 'react-bootstrap';
import SelectorDistribuidor from './SelectorDistribuidor';
import InformacionCliente from './InformacionCliente';
import DatosFiscalesDisplay from './DatosFiscalesDisplay';

/**
 * Componente para la sección de datos de facturación
 */
const SeccionDatosFacturacion = ({
    totales,
    cliente,
    distribuidores,
    datosFacturacion,
    onCambiarTipoDistribuidor,
    onSeleccionarDistribuidor,
    onActualizarDatos
}) => {
    return (
        <Card className="mb-3">
            <Card.Header className="bg-light">
                <h5>Datos de facturaci&oacute;n</h5>
            </Card.Header>
            <Card.Body>
                <SelectorDistribuidor
                    esDistribuidor={totales.bIsDistribucion}
                    onCambiarTipo={onCambiarTipoDistribuidor}
                    distribuidores={distribuidores}
                    distribuidorSeleccionado={datosFacturacion.idDistribuidor}
                    onSeleccionarDistribuidor={onSeleccionarDistribuidor}
                />

                {cliente.idClienteAkasia && cliente.vNombre && (
                    <Row>
                        <Col md={12} className="mb-3 mt-4 mb-md-0 fs-1">
                            <InformacionCliente
                                idCliente={cliente.idClienteAkasia}
                                nombre={cliente.vNombre}
                                apellidos={cliente.vApellidos}
                                esRecompra={totales.bIsRecompra}
                            />
                        </Col>
                    </Row>
                )}

                <Row>
                    <Col className="fs--1">
                        <DatosFiscalesDisplay
                            datosFacturacion={datosFacturacion}
                            esDistribuidor={totales.bIsDistribucion}
                            onActualizar={onActualizarDatos}
                        />
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

SeccionDatosFacturacion.propTypes = {
    totales: PropTypes.shape({
        bIsDistribucion: PropTypes.bool,
        bIsRecompra: PropTypes.bool
    }).isRequired,
    cliente: PropTypes.shape({
        idClienteAkasia: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        vNombre: PropTypes.string,
        vApellidos: PropTypes.string,
        vRazonSocial: PropTypes.string,
        vRfc: PropTypes.string,
        vNumRegTrib: PropTypes.string,
        idCatUsoCFDI: PropTypes.number,
        idCatRegimenFiscal: PropTypes.number,
        vCp: PropTypes.string,
        vDireccionFiscal: PropTypes.string,
        vEstadoDepProv: PropTypes.string,
        vPais: PropTypes.string,
        vEmailFacturacion: PropTypes.string,
        vTelefonoFacturacion: PropTypes.string,
        vCodigoUso: PropTypes.string,
        vDescripcionUsoCFDI: PropTypes.string,
        vCodigoRegimen: PropTypes.string,
        vDescripcionRegimenFiscal: PropTypes.string
    }).isRequired,
    distribuidores: PropTypes.array.isRequired,
    datosFacturacion: PropTypes.object.isRequired,
    onCambiarTipoDistribuidor: PropTypes.func.isRequired,
    onSeleccionarDistribuidor: PropTypes.func.isRequired,
    onActualizarDatos: PropTypes.func.isRequired
};

export default SeccionDatosFacturacion;
